<!--
 * @Author: 汪俊洪
 * @Date: 2021-08-04 14:17:15
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2021-08-10 15:54:05
 * @Description: 评价
-->
<template>
  <div>
    <div class="box-shadow" v-if="signVo">
      <div class="right-content" style="width:1050px">
        <div class="commnet-top">
          <div class="comment-left">
            <img src="../../../../../public/img/4_03.png" />
            <p class="com-one com-new">{{$t('evaluate.title')}}</p>
          </div>
          <div class="comment-right">
            <div style="display:flex;">
              <span class="row-item-label comment-row">{{$t('evaluate.quality')}}：</span>
              <label class="row-item-conent">
                <el-rate
                  class="rate-choose"
                  :disabled="evaluated ? true : false"
                  v-model="dataForm.serviceQuality"
                ></el-rate>
              </label>
            </div>
            <div style="display:flex;">
              <span class="row-item-label comment-row">{{$t('evaluate.easier')}}：</span>
              <label class="row-item-conent">
                <el-rate
                  class="rate-choose"
                  :disabled="evaluated ? true : false"
                  v-model="dataForm.serviceFacilitate"
                ></el-rate>
              </label>
            </div>
            <div style="display:flex;">
              <span class="row-item-label comment-row">{{$t('evaluate.speed')}}：</span>
              <label class="row-item-conent">
                <el-rate
                  class="rate-choose"
                  :disabled="evaluated ? true : false"
                  v-model="dataForm.serviceResponse"
                ></el-rate>
              </label>
            </div>
          </div>
        </div>
        <div class="comment-bottom">
          <div class="bottom-left">{{$t('evaluate.feedback')}}：</div>
          <div class="bottom-right">
            <label
              class="row-item-conent"
              style="max-width:880px; width:880px;"
            >
              <template v-if="evaluated">
                {{ dataForm.feedbackContent || '-' }}
              </template>
              <el-input
                v-else
                type="textarea"
                :maxlength="200"
                :autosize="{ minRows: 4 }"
                :placeholder="$t('evaluate.placeholder')"
                v-model="dataForm.feedbackContent"
                show-word-limit
              ></el-input>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div style="width:100%;margin-top:15px;height:40px">
      <el-button style="float:right" @click="cancelGoods()">{{
        evaluated ? $t('close') : $t('cancel')
      }}</el-button>
      <el-button
        type="primary"
        style="float:right;margin-right:10px"
        v-if="!evaluated"
        @click="saveGoods()"
        >{{$t('evaluate.name')}}</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    evaluated: {
      type: Boolean,
      default: false
    },
    signVo: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      dataForm: {}
    }
  },
  created () {
    this.dataForm = this.signVo
  },
  methods: {
    // 取消或者关闭
    cancelGoods () {
      this.$emit('cancelGoods')
    },
    // 评价
    saveGoods () {
      this.$emit('saveGoods', this.dataForm)
    }
  }
}
</script>

<style lang="scss" scoped>
// 评价
.box-shadow {
  padding: 40px;
}
.comment-left {
  width: 246px;
  height: 80px;
  float: left;
}
.comment-right {
  float: left;
  height: 80px;
  width: 800px;
  display: flex;
  justify-content: space-between;
  padding-right: 20px;
  padding-left: 50px;
  align-items: center;
}
.commnet-top {
  height: 90px;
}
.submit-btn {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}
.comment-bottom {
  height: 120px;
}
.bottom-left {
  float: left;
  width: 80px;
}
.bottom-right {
  float: left;
  width: 938px;
}
.comment-left img {
  width: 60px;
  height: 60px;
  float: left;
  margin-right: 20px;
}
.com-one {
  font-size: 18px;
  color: #333;
  font-weight: bold;
  margin: 5px 0;
}
.com-new {
  margin-top: 15px;
  margin-bottom: 0px;
}
</style>
